// extracted by mini-css-extract-plugin
module.exports = {"vr":"InfoPills_vr__2mtVh","information":"InfoPills_information__2yp5s","pill":"InfoPills_pill__g8nvf"};